import React from 'react'
import { SkewBg, IntroContent } from './Intro/index.js'
import CoolStuff  from './CoolStuff/CoolStuff'
import PortfolioPart  from './PortfolioPart/PortfolioPart'
import StandAloneSolutions  from './StandAloneSolutions/StandAloneSolutions'
import MeetTheTeam  from './MeetTheTeam/MeetTheTeam'
import Achievements  from './Achievements/Achievements'
import InstaFeed  from './InstaFeed/InstaFeed'
import Clients  from './Clients/Clients'
import LemonSection  from './LemonSection/LemonSection'
import Header from '../Header/Header'


// PATTERN
import bgPattern from '../../assets/bgPattern.png'


export default class Home extends React.Component{
  render(){
    return(
    	<div>
      <Header />
    		<SkewBg />
  			<IntroContent />
        <div className="ChipStuff"
        style={{
          backgroundImage: `url('${bgPattern}')`,
          height: 'inherit',
          zIndex: 313,
          width: '100vw',
          backgroundSize: 'contain',
        }}>
          <CoolStuff />
          <PortfolioPart />
          <StandAloneSolutions />
          <MeetTheTeam />
          <Achievements />
          <InstaFeed />
          <Clients />
          <LemonSection />
        </div>
    	</div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/Components/Home/Home.js